export class ResultStatus {
    errorCode?: string;
    errorMessage?: string;
    errorDetails?: string;
    statusCode?: string;
  }